module.exports = __webpack_public_path__ + "static/media/iot.5d40f4ef.png";